import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d107aa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container pt-4"
}
const _hoisted_2 = { class: "row my-3" }
const _hoisted_3 = { class: "col-12 text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-center py-3" }, " ¡Gracias por tu interés en la Clínica de manejo! ", -1))
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-uppercase fw-bold" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-center py-3" }, " ¡Esperamos que pronto disfrutes de esta nueva experiencia! ", -1))
const _hoisted_8 = { class: "col-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppResumeComponent = _resolveComponent("AppResumeComponent")!
  const _component_AppButtonResetNav = _resolveComponent("AppButtonResetNav")!

  return (_ctx.state.evento)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_AppResumeComponent, { logo: "/img/icons/checked.svg" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h4", _hoisted_5, [
              _createTextVNode(" Un asesor de "),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.state.evento.theme), 1),
              _createTextVNode(" se comunicará con vos a la brevedad. ")
            ]),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_AppButtonResetNav)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}